module.exports = __webpack_public_path__ + "static/media/ic-landing-culture.a9029645.png";